<template>
  <DashboardLeads v-if="isDebug"/>
  <DashboardCompanyLeads v-else/>
</template>
<script>
import { core } from "../../config/pluginInit";
import {isDebug} from '../../Utils/account';
import DashboardLeads from './Components/DashboardLeads.vue';
import DashboardCompanyLeads from './Components/DashboardCompanyLeads.vue';

export default {
  name: "Dashboard",
  components: {DashboardLeads, DashboardCompanyLeads},
  data(){
    return {
      isDebug: isDebug()
    }
  }
    
  // mounted() {
  //   core.index();
  // },
};
</script>